import type { DataSchema } from 'types';
import { TABLE_CELL_TYPE } from 'types/enums';

export const usersDataScheme = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
    hidden: true,
  },
  fullName: {
    label: 'fullName',
    type: TABLE_CELL_TYPE.USERNAME,
    translationKey: 'user.contacts.contacts.person',
  },
  email: {
    label: 'email',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'user.contacts.contacts.email',
  },
  phoneNumber: {
    label: 'phoneNumber',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'user.contacts.contacts.phoneNumber',
  },
  organization: {
    label: 'organization',
    type: TABLE_CELL_TYPE.NAME_ARRAY,
    translationKey: 'user.contacts.contacts.organization',
  },
} satisfies DataSchema;
